import axios from 'axios';
import {ref, onMounted} from 'vue';

import {URLS} from '../config';

export function useGetTransactions() {
  const transactions = ref([]);
  const transactionsLoading = ref(false);

  const getTransactions = async () => {
    transactionsLoading.value = true;

    try {
      const response = await axios.get(URLS.GET_TRANSACTIONS);
      transactions.value = response.data.transactions;
    } catch (error) {
      console.error(error);
    } finally {
      transactionsLoading.value = false;
    }
  };

  onMounted(() => {
    getTransactions();
  });

  return {
    transactions,
    transactionsLoading,
  };
}
